import { type ComponentProps } from "solid-js"

export function Spinner(props: {
  class?: string
  classList?: ComponentProps<"div">["classList"]
  style?: ComponentProps<"div">["style"]
}) {
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      data-component="spinner"
      classList={{
        ...props.classList,
        [props.class ?? ""]: !!props.class,
      }}
      fill="none"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="6" data-slot="spinner-background" stroke-width="2" />
      <circle
        cx="8"
        cy="8"
        r="6"
        data-slot="spinner-progress"
        pathLength="100"
        stroke-width="2"
        stroke-dasharray="33 67"
      />
    </svg>
  )
}
